import { render } from "./UpdateMenuModifierItem.vue?vue&type=template&id=176c81a6&scoped=true"
import script from "./UpdateMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./UpdateMenuModifierItem.vue?vue&type=script&lang=js"

import "./UpdateMenuModifierItem.vue?vue&type=style&index=0&id=176c81a6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176c81a6"]])

export default __exports__